<script lang="ts">
  interface Props {
    colorVar: string;
    align: "top" | "bottom";
  }
  let { colorVar, align }: Props = $props();
</script>

<div class="gradient-wrapper">
  <div class="scroll-gradient {align}" style:--color="var({colorVar})"></div>
</div>

<style lang="scss">
  @use "@astlai/common/styles/mixins" as lib;

  .gradient-wrapper {
    position: relative;
    .scroll-gradient {
      z-index: 1;
      position: absolute;
      width: 100%;
      background: linear-gradient(var(--color), hsla(0, 0%, 0%, 0));
      height: 1rem;

      &.bottom {
        bottom: -1rem;
        background: linear-gradient(var(--color), hsla(0, 0%, 0%, 0));
      }
      &.top {
        top: -1rem;
        background: linear-gradient(hsla(0, 0%, 0%, 0), var(--color));
      }
    }
  }
</style>
